import React, { useEffect, useRef, useState } from "react";
import "./css/campaignsViewMore.css";
import { Line } from "react-chartjs-2";
import { getIconSrc ,getImgSrc} from "../../../helpers/getImgSrc";
import { Notifications } from "../../../components/Notifications";
import DropdownFilter from "../../../partials/filter/DropdownFilter";
import { useNavigate, useParams } from "react-router-dom";
import DateRangePicker from "../../../partials/date-range-picker/DateRangePicker";
import gsap from "gsap";
import { handleApi } from "../../../utils/authentication";
import { toast } from "react-toastify";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import { getAdsDashboardMetrics, fetchFacebookActivity, fetchDemographicData, fetchPlacementsData, fetchLocationsData } from "../../../services/ad_details_services"
import { getPlatformName } from "../../../helpers/getPlatformName"
import './campaign_view_more.css';
import './new_campaign_view_more.css'
import { getSvgIcons } from "../../../helpers/getReactIcons";
import PieChart from "../../../components/client/dashboard/PieChart";
import { LeadsBarChart } from "../../../components";
import CampaignsViewMoreMetricsDetails from "./components/CampaignsViewMoreMetricsDetails";
import FacebookAdsPublisherPlatformMetricsList from "./FacebookAdsPublisherPlatformMetricsList";

const SingleLineChart = ({ data, lineColor }) => {
  const options = {
    scales: {
      x: { display: false },
      y: { display: false },
    },
    plugins: {
      legend: { display: false },
    },
    elements: {
      point: { radius: 0 },
      line: { borderColor: lineColor },
    },
  };

  return <Line data={data} options={options} />;
};



const CampaignsViewMore = () => {

  const campaigns_view_more_ref = useRef()

  const [selectedDateRange, setSelectedDateRange] = useState({ value: null, label: "All Time" })
  const [customRange, setCustomRange] = useState({
    startDate: null,
    endDate: null
  })

  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [isLoading, setIsLoading] = useState(true)
  const [adsData, setAdsData] = useState()
  const [dashboardData, setDashboardData] = useState({})
  const [facebookActivityData, setFacebookActivityData] = useState({})
  const [facebookActivityTotal, setFacebookActivityTotal] = useState(0)
  const [facebookAudienceData, setFacebookAudienceData] = useState({
    people: {},
    placements: [],
    locations: [],
    facebook_total_impressions: 0,
    facebook_placements_impressions: 0


  })
  const [tab, setTab] = useState('people')
  const [adDetailsTab, setAdDetailsTab] = useState('audience_insights')
  const navigate = useNavigate()
  const { ads_id, platform_id } = useParams(); // Extracting `id` from URL params

  const data = {
    labels: ["January", "February", "March", "April", "May"],
    datasets: [
      {
        label: "Reactions",
        data: [0, 59, 10, 81, 6],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Comments",
        data: [4, 39, 60, 7, 46],
        fill: false,
        backgroundColor: "#FFB1E0",
        borderColor: "#FFB1E0",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Shares",
        data: [35, 29, 0, 1, 36],
        fill: false,
        backgroundColor: "#95F3FA",
        borderColor: "#95F3FA",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Post Link Clicks",
        data: [25, 9, 40, 51, 26],
        fill: false,
        backgroundColor: "#FFE58A",
        borderColor: "#FFE58A",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
      {
        label: "Other Post Clicks",
        data: [15, 9, 30, 41, 16, 5, 0],
        fill: false,
        backgroundColor: "#8AABFF",
        borderColor: "#8AABFF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        display: true,
        ticks: {
          display: false,
          stepSize: 15, // Set y-axis ticks with a 50 points gap
        },
        grid: {
          drawBorder: false,

          borderDash: [5, 5], // Ensure y-axis grid line is dashed
        },
      },
      x: {
        display: true,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 30,
          boxHeight: 10,
          padding: 20,
          usePointStyle: true,
          pointStyle: "rectRounded",
          color: "#908DAD", // Set legend text color
        },
      },
      tooltip: {
        mode: "index", // Show tooltip for the entire column
        intersect: false,
      },
    },
    layout: {
      padding: {
        top: 20,
      },
    },
  };

  const reactionsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 59, 10, 81],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const leadsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 9, 10, 81],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const clicksData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 1, 6, 0],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const applicationsData = {
    labels: ["January", "February", "March", "April"],
    datasets: [
      {
        data: [0, 5, 60, 51, 0],
        fill: false,
        backgroundColor: "#D3A4FF",
        borderColor: "#D3A4FF",
        borderWidth: 1,
        pointStyle: "rect",
        pointRadius: 5,
      }
    ],
  };
  const handleDateRangeSelect = (selectedOption) => {
    if (selectedOption.value == "Custom Range") {
      setShowDateRangePicker(true)

    } else {
      setSelectedDateRange(selectedOption)
    }
  };
  useEffect(() => {
    if (customRange?.startDate || customRange?.endDate) {
      setSelectedDateRange({
        value: "Custom Range",
        label: "Custom Range"
      })
    }
  }, [customRange?.startDate, customRange?.endDate]);


  useEffect(() => {
    gsap.from(campaigns_view_more_ref.current, {
      y: 500,
      duration: 1,
      opacity: 0,
      ease: "easeIn",
      onComplete: () => {
        if (campaigns_view_more_ref.current && campaigns_view_more_ref.current.style.transform)
          campaigns_view_more_ref.current.style.transform = "";
      },
    });

  }, []);

  //getting campaign details
  const getAdsDetails = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("ads_id", ads_id);
      formData.append("platform_id", platform_id);
      formData.append("days", selectedDateRange?.value);

      const startDate = customRange?.startDate
        ? customRange?.startDate.split("/").reverse().join("-")
        : "";

      const endDate = customRange?.endDate
        ? customRange?.endDate.split("/").reverse().join("-")
        : "";

      formData.append("start_date", startDate);
      formData.append("end_date", endDate);



      let result = await handleApi("get_ad_details", method, headers, formData);
      if (result?.success) {
        
        setAdsData({...result?.data,platform_id:platform_id})

        if (getPlatformName(platform_id) === "Facebook") {


          //header Metrics Data
          if (result?.data?.dashboard_metrics_data?.link_clicks) {
            setDashboardData(
              { ...result?.data?.dashboard_metrics_data }
            )
          }
          //Activity metrics data
          let facebook_activity_response = result?.data?.activity_metrics_data

          if (facebook_activity_response) {
            setFacebookActivityData(facebook_activity_response)
            let total_facebook_activity = 0
            Object.values(facebook_activity_response).forEach(value => {
              total_facebook_activity = total_facebook_activity + parseInt(value)
            });
            setFacebookActivityTotal(total_facebook_activity)


          }

          //facebook demographic data
          //people
          let facebook_demographic_response = result?.data?.demographic_metrics_data;

          if (facebook_demographic_response) {
            setFacebookAudienceData((prev) => {

              return { ...prev, people: facebook_demographic_response }

            })

            const labels = [];
            const totalCounts = [];
            let total_female_count = 0;
            let total_male_count = 0;
            let total_unknown_count = 0;
            for (const [ageGroup, data] of Object.entries(facebook_demographic_response)) {
              labels.push(ageGroup);
              const total = data.female + data.male + data.unknown;
              total_male_count = total_male_count + data.male
              total_female_count = total_female_count + data.female
              total_unknown_count = total_unknown_count + data.unknown
              totalCounts.push(total);
            }
            setFacebookAudienceData((prev) => {

              return {
                ...prev, people_bar_chart: {
                  labels,
                  totalCounts
                },
                gender_distribution: {
                  male: total_male_count,
                  female: total_female_count,
                  unknown: total_unknown_count
                }

              }

            })

          }


          // placements data
          let facebook_placement_data = result?.data?.placement_metrics_data
          if (facebook_placement_data?.length > 0) {
            setFacebookAudienceData((prev) => {

              return { ...prev, placements: facebook_placement_data }

            })
            let total_impressions = 0;
            facebook_placement_data?.forEach(location => {
              total_impressions = total_impressions + parseInt(location?.impressions)

            })
            setFacebookAudienceData((prev) => {
              return { ...prev, facebook_placements_impressions: total_impressions }

            })
          }

          //locations data
          let facebook_locations_data = result?.data?.locations_metrics_data
          if (facebook_locations_data?.length > 0) {
            setFacebookAudienceData((prev) => {

              return { ...prev, locations: facebook_locations_data }

            })
            let total_impressions = 0;
            facebook_locations_data?.forEach(location => {
              total_impressions = total_impressions + parseInt(location?.impressions)

            })
            setFacebookAudienceData((prev) => {
              return { ...prev, facebook_total_impressions: total_impressions }

            })
          }else{
                setFacebookAudienceData((prev) => {

              return { ...prev, locations: [],facebook_total_impressions:0 }

            })
          }





        }

      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to get campaign details"
        );
      }
    } catch (e) {
      toast.error(e.message ? e.message : "Failed to get campaign details");
    } finally {
      setIsLoading(false);
    }
  };



  const getAdDetailsPageData = async () => {
    try {
      let platformName = getPlatformName(platform_id)
      if (platformName === "Facebook") {
        // let result = await getAdsDashboardMetrics(ads_id)

        // if (result?.link_clicks) {
        //   setDashboardData(result)
        // }
        // let facebook_activity_response = await fetchFacebookActivity(ads_id)
        // console.log(facebook_activity_response, "Facebook Activity Response")
        // if (facebook_activity_response) {
        //   setFacebookActivityData(facebook_activity_response)
        //   let total_facebook_activity = 0
        //   Object.values(facebook_activity_response).forEach(value => {
        //     total_facebook_activity = total_facebook_activity + parseInt(value)
        //   });
        //   setFacebookActivityTotal(total_facebook_activity)


        // }
        // let facebook_demographic_response = await fetchDemographicData(ads_id)
        // let facebook_placement_data = await fetchPlacementsData(ads_id)
        // let facebook_locations_data = await fetchLocationsData(ads_id)

        //  //locations data
        // if (facebook_locations_data?.length > 0) {
        //   setFacebookAudienceData((prev) => {

        //     return { ...prev, locations: facebook_locations_data }

        //   })
        //   let total_impressions = 0;
        //   facebook_locations_data?.forEach(location => {
        //     total_impressions = total_impressions + parseInt(location?.impressions)

        //   })
        //   setFacebookAudienceData((prev) => {
        //     return { ...prev, facebook_total_impressions: total_impressions }

        //   })
        // }

        // placements data
        // if (facebook_placement_data?.placement_chart_data?.data?.length > 0) {
        //   setFacebookAudienceData((prev) => {

        //     return { ...prev, placements: facebook_placement_data?.placement_chart_data?.data }

        //   })
        //   let total_impressions = 0;
        //   facebook_placement_data?.placement_chart_data?.data?.forEach(location => {
        //     total_impressions = total_impressions + parseInt(location?.impressions)

        //   })
        //   setFacebookAudienceData((prev) => {
        //     return { ...prev,facebook_placements_impressions: total_impressions }

        //   })
        // }

        //people
        // if(facebook_demographic_response)
        // {
        //   setFacebookAudienceData((prev) => {

        //     return { ...prev, people: facebook_demographic_response }

        //   })

        // }

      }

    }
    catch (e) {
      console.log(e)
    }

  }


  const peopleBarChartData =
    [{
      label: 'Age Percentage',

      data: facebookAudienceData?.people_bar_chart?.totalCounts,
      backgroundColor: [
        '#9b87f5',

      ],
      borderColor: [
        '#9b87f5',

      ],
      borderWidth: 1
    }]




  useEffect(() => {
    getAdsDetails()
    getAdDetailsPageData()

  }, [selectedDateRange]);

  const headingMetricsData = [
    {
      heading: "Key Metrics",
      metrics: [
        {
          metrics_name: 'Budget/Spent',
          metrics_icon: getSvgIcons('dollar', { color: '#98afbb' }),
          value: dashboardData?.spent?.value ?? 0,
          description:dashboardData?.spent?.description ?? ''
        },
        {
          metrics_name: 'Impressions',
          metrics_icon: getSvgIcons('eye', { color: '#98afbb' }),
          value: dashboardData?.impressions?.value  ?? 0,
           description:dashboardData?.impressions?.description ?? ''
        },
        {
          metrics_name: 'Reach',
          metrics_icon: getSvgIcons('people', { color: '#98afbb' }),
          value: dashboardData?.reach?.value  ?? 0,
           description:dashboardData?.reach?.description ?? ''
        },
        {
          metrics_name: 'Views',
          metrics_icon: getSvgIcons('percentage', { color: '#98afbb' }),
          value: dashboardData?.views?.value  ?? 0,
           description:dashboardData?.views?.description ?? ''
        }
      ]
    }, {
      heading: "Engagement",
      metrics: [
        {
          metrics_name: 'Video Views',
          metrics_icon: getSvgIcons('video', { color: '#98afbb' }),
          value: facebookActivityData?.video_view ?? 0,
           description:''
        },
        {
          metrics_name: 'Post Reactions',
          metrics_icon: getSvgIcons('eye', { color: '#98afbb' }),
          value: dashboardData?.post_reactions?.value  ?? 0,
           description:dashboardData?.post_reactions?.description ?? ''
        },
        {
          metrics_name: 'Post Engagements',
          metrics_icon: getSvgIcons('document', { color: '#98afbb' }),
          value: dashboardData?.post_engagements?.value  ?? 0,
           description:dashboardData?.post_engagements?.description ?? ''
        },
        {
          metrics_name: 'Link Clicks',
          metrics_icon: getSvgIcons('clicks', { color: '#98afbb' }),
          value: dashboardData?.link_clicks?.value  ?? 0,
           description:dashboardData?.link_clicks?.description ?? ''
        }
      ]

    }

  ]

  //console.log(dashboardData,"Facebook Data")

  return (
    <>
      {isLoading ? <LoadingSpinner /> :
        <div ref={campaigns_view_more_ref}>

          <div className="campaigns-view-more-header">
            <div className="campaigns-view-more-header-top-section d-flex justify-content-between align-items-center flex-wrap">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/client/campaigns");
                  }}
                  className="d-flex align-items-center"
                >
                  <img className="" src={getIconSrc("arrow", "svg")}></img>
                </div>
                <div>
                  <span className="campaigns-view-more-page-title">
                    {platform_id ? getPlatformName(platform_id) : ''} 
                    {adsData?.name}
                    
                  </span>
                  <span
                    className="ms-2 "
                    style={{
                      color: "gray",
                      fontSize: "14px",
                      fontFamily: "aeonik_medium",
                    }}
                  >
                    {/* (August 21 App deadline Campaign) */}
                  </span>
                </div>


              </div>
              <div className="d-flex align-items-center gap-3">
            
                <DropdownFilter
                  styling={{ backgroundColor: "transparent" }}
                  label={"Date"}
                  onSelect={handleDateRangeSelect}
                  options={[
                    { value: null, label: "All Time" },
                    { value: "30 Days", label: "30 Days" },
                    { value: "90 Days", label: "90 Days" },
                    { value: "180 Days", label: "180 Days" },
                    { value: "Custom Range", label: "Custom Range" },
                  ]}
                  selectedOption={{
                    value: selectedDateRange.value,
                    label: selectedDateRange.label,
                  }}
                />
                <Notifications />
                <div style={{ cursor: "pointer" }}>
                  <img className="" src={getIconSrc("export", "svg")}></img>
                </div>
              </div>
            </div>
            {getPlatformName(platform_id) === "Facebook" ?
              <div className="campaigns-view-more-header-content row m-0  ">
                <div className="col-md-3 row m-0 d-flex align-items-center">
                  <div className="col-md-5">
                    <div className="header-content-label d-flex align-items-center gap-3">
                      <span>REACTIONS</span>
                      <span style={{cursor:'pointer'}} data-bs-toggle="tooltip"  data-bs-placement="left" title={dashboardData?.post_reactions?.description}>{getSvgIcons('info',{})}</span>
                      </div>
                    <div className="header-content-value">{dashboardData?.post_reactions?.value ?? 0}</div>
                  </div>
                  <div className="col-md-7">
                    {/* <SingleLineChart data={reactionsData} lineColor="#D3A4FF" /> */}
                  </div>
                </div>
                <div className="col-md-3 row m-0 d-flex align-items-center">
                  <div className="col-md-5">
                    <div className="header-content-label d-flex align-items-center gap-3">
                      
                     <span>CLICKS</span>
                      <span style={{cursor:'pointer'}} data-bs-toggle="tooltip"  data-bs-placement="left" title={dashboardData?.link_clicks?.description}>{getSvgIcons('info',{})}</span>
                      </div>
                    <div className="header-content-value">{dashboardData?.clicks?.value  ? dashboardData?.clicks?.value : 0}</div>

                  </div>
                  <div className="col-md-7">
                    {/* <SingleLineChart data={clicksData} lineColor="#FFB1E0" /> */}
                  </div>
                </div>
                <div className="col-md-3 row m-0 d-flex align-items-center">
                  <div className="col-md-5">
                    {/* <div className="header-content-label">LEADS</div>
            <div className="header-content-value">852</div> */}
                    <div className="header-content-label d-flex align-items-center gap-3">
                      
                       <span>VIEWS</span>
                      <span style={{cursor:'pointer'}} data-bs-toggle="tooltip"  data-bs-placement="left" title={dashboardData?.views?.description}>{getSvgIcons('info',{})}</span>

                      </div>
                    <div className="header-content-value">{dashboardData?.views?.value  ? dashboardData?.views?.value  : 0}</div>

                  </div>
                  <div className="col-md-7">
                    {/* <SingleLineChart data={leadsData} lineColor="#95F3FA" /> */}
                  </div>
                </div>
                <div className="col-md-3 row m-0 d-flex align-items-center">
                  <div className="col-md-5">
                    {/* <div className="header-content-label">APPLICATIONS</div>
            <div className="header-content-value">852</div> */}
                    <div className="header-content-label d-flex align-items-center gap-3">
                    
                       <span>Post Engagements</span>
                      <span style={{cursor:'pointer'}} data-bs-toggle="tooltip"  data-bs-placement="left" title={dashboardData?.post_engagements?.description}>{getSvgIcons('info',{})}</span>
                      </div>
                    <div className="header-content-value">{dashboardData?.post_engagements?.value  ? dashboardData?.post_engagements?.value  : 0}</div>


                  </div>
                  <div className="col-md-7">
                    {/* <SingleLineChart data={applicationsData} lineColor="#FFE58A" /> */}
                  </div>
                </div>
              </div> :
              <div className="campaigns-view-more-header-content row m-0 ">
                {adsData?.header_metrics_data?.length > 0 && adsData?.header_metrics_data.map((metrics) => {
                  return <div className="col-md-3 row m-0 d-flex align-items-center">
                    <div className="col-md-5">
                      <div className="header-content-label d-flex align-items-center gap-2">
                      
                       <span>{metrics?.name ?? ""}</span>
                        <span style={{cursor:'pointer'}} data-bs-toggle="tooltip"  data-bs-placement="left" title={metrics?.description}>{getSvgIcons('info',{})}</span>


                      </div>
                      <div className="header-content-value">{metrics?.value ?? 0}</div>
                    </div>
                    <div className="col-md-7">
                      {/* <SingleLineChart data={reactionsData} lineColor="#D3A4FF" /> */}
                    </div>
                  </div>

                })}



              </div>}



            {/* {getPlatformName(platform_id) !== "Facebook" ? */}

              <div className="campaigns-view-more-body  ">
                <div className="campaigns-view-more-card">
                 { getPlatformName(platform_id) == "Facebook" &&
                  <div className="campaigns-view-more-card-header d-flex justify-content-between flex-wrap gap-2 ">
                
                    <div className="d-flex flex-column gap-2">
                      <div className="chart-label d-flex align-items-center">
                        <span>REACTIONS</span>
                        <span style={{cursor:'pointer'}} data-bs-toggle="tooltip" className="px-3" data-bs-placement="left" title={dashboardData?.post_reactions?.description}>{getSvgIcons('info',{})}</span>

                      </div>
                      <div className="chart-value">{dashboardData?.post_reactions?.value  ?? 0}</div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="chart-label d-flex align-items-center">
                         <span>Views</span>
                         <span style={{cursor:'pointer'}} data-bs-toggle="tooltip" className="px-3" data-bs-placement="left" title={dashboardData?.views?.description}>{getSvgIcons('info',{})}</span>

                      </div>
                      <div className="chart-value">{dashboardData?.views?.value  ? dashboardData?.views?.value  : 0}</div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="chart-label d-flex align-items-center">
                          <span>Post Engagements</span>
                        <span style={{cursor:'pointer'}} data-bs-toggle="tooltip" className="px-3" data-bs-placement="left" title={dashboardData?.post_engagements?.description}>{getSvgIcons('info',{})}</span>

                      </div>
                      <div className="chart-value">{dashboardData?.post_engagements?.value  ? dashboardData?.post_engagements?.value  : 0}</div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="chart-label d-flex align-items-center">
                         <span>POST LINK CLICKS</span>
                        <span style={{cursor:'pointer'}} data-bs-toggle="tooltip" className="px-3" data-bs-placement="left" title={dashboardData?.link_clicks?.description}>{getSvgIcons('info',{})}</span>

                      </div>
                      <div className="chart-value">{dashboardData?.link_clicks?.value  ? dashboardData?.link_clicks?.value  : 0}</div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="chart-label d-flex align-items-center">
                       
                        <span> Cost Per Messaging Conversation</span>
                        <span style={{cursor:'pointer'}} data-bs-toggle="tooltip" className="px-3" data-bs-placement="left" title={dashboardData?.cost_per_messaging_conversation?.description}>{getSvgIcons('info',{})}</span>

                      </div>
                      <div className="chart-value">{dashboardData?.cost_per_messaging_conversation?.value  ? dashboardData?.cost_per_messaging_conversation?.value  : 0}</div>
                    </div>
                  </div>}


                  <div className="campaigns-view-more-card-body ">
                    {getPlatformName(platform_id) !== "Facebook" ?
                      <CampaignsViewMoreMetricsDetails 
                      adsData={adsData}
                      />
                      // <Line data={data} options={options} /> 
                      :
                      <>
                       <div className="ad_details_main_container " 
          // style={getPlatformName(platform_id) === "Facebook" ? {} : { display: 'none' }}
          >
            <section className="ad_details_header_section d-none">
              <h4>Facebook Ad Details</h4>
              <span>Comprehensive view of performance metrics for ad ID:{adsData?.ads_id}</span>

            </section>
            <section className="ad_details_metrics_overview">
              <div className="ad_details_metrics_container">
                <div className="ad_details_metrics_container_top d-none">
                  <div className="ad_details_metrics_heading_container">
                    <div className="ad_details_metrics_heading_container_top">
                      <div className="ad_details_metrics_heading_logo">
                        <p>AD</p>
                      </div>
                      <div className="ad_details_metrics_heading_content">
                        <h4>{adsData?.name}</h4>
                        <p>Ad ID:{adsData?.ads_id}</p>

                      </div>

                    </div>
                    <div className="ad_details_metrics_heading_container_bottom">
                      <div className="ad_details_metrics_heading_status_badge">
                        <span>{adsData?.data?.status}</span>
                      </div>
                      <p>{adsData?.external_campaign_details?.start_date} to {adsData?.external_campaign_details?.end_date ?? "--"}</p>

                    </div>

                  </div>

                </div>
                <div className="ad_details_metrics_container_bottom">

                  {headingMetricsData?.map((data) => {
                    return <div className="metrics_container">

                      <div className="ad_details_metrics_container_bottom_heading">
                        <p className="text-dark">{data?.heading}</p>
                      </div>
                      <div className="ad_details_metrics_container_bottom_metrics_card_container">
                        {data?.metrics?.length > 0 && data?.metrics?.map((metric) => {

                          return <div className="ad_details_metrics_card">
                            <div className="ad_details_metrics_card_top">
                              <span>{metric?.metrics_icon}</span>
                              <span>{metric?.metrics_name}</span>
                              <span style={{cursor:'pointer'}} data-bs-toggle="tooltip" className="px-1" data-bs-placement="left" title={metric?.description}>{getSvgIcons('info',{})}</span>
                            </div>
                            <div className="ad_details_metrics_card_bottom">
                              <p>{metric?.value}</p>
                              <div>
                                {/* <span>{getSvgIcons('arrow-up', { color: '#166556' })}</span> */}
                                <span></span>
                              </div>

                            </div>
                          </div>

                        })}


                      </div>

                    </div>

                  })}


                </div>
              </div>

            </section>
            <section className="ads_details_metrics_tabs_section">
              <div className="ads_details_metrics_tabs_container">
                {/* <div className={`ads_details_metrics_tab ${adDetailsTab === "ad_content" ? "ads_details_metrics_tab_active" : ""}`} onClick={() => setAdDetailsTab('ad_content')}>
                  <p>Ad Content</p>
                </div> */}
                <div className={`ads_details_metrics_tab ${adDetailsTab === "audience_insights" ? "ads_details_metrics_tab_active" : ""}`} onClick={() => setAdDetailsTab('audience_insights')}>
                  <p>Audience Insights</p>
              
                </div>
                {/* <div className={`ads_details_metrics_tab ${adDetailsTab === "conversions" ? "ads_details_metrics_tab_active" : ""}`} onClick={() => setAdDetailsTab('conversions')}>
                  <p>Conversions</p>
                </div> */}

              </div>
              {adDetailsTab === "ad_content" &&
                <div className="ads_details_metrics_tabs_content_container" style={{ minHeight: '70vh' }}>
                  <div className="ads_details_metrics_campaign_details_container">
                    <div className="ads_details_metrics_campaign_details_heading_container">
                      <h4>Campaign Details</h4>
                    </div>
                    <div className="ads_details_metrics_campaign_details_content_container">
                      <div className="ads_details_metrics_campaign_details_content_container_top">
                        <p>Placement Impressions</p>
                      </div>
                      <div className="ads_details_metrics_campaign_details_content_container_bottom">

                      </div>


                    </div>


                  </div>



                </div>}
              {adDetailsTab === "audience_insights" &&
                <div className="ads_details_metrics_tabs_content_container">
                  <div className="ads_details_metrics_tabs_content_container_top">
                    <div className="ads_details_metrics_tabs_content_card">
                      <div className="heading">
                        <h4>Impression Distribution by Age Group</h4>
                        <span>This data shows the distribution of impressions based on the audience’s age and gender as per their Facebook profile at the time of ad delivery.</span>
                      </div>
                      <div className="content">
                        <div className="bar_graph_content_container">
                          {isLoading ? <LoadingSpinner /> :
                            <LeadsBarChart indexAxis="y"
                              labels={facebookAudienceData?.people_bar_chart?.labels}
                              bar_graph_data={peopleBarChartData} 
                              
                              />
                              }
                        </div>

                      </div>

                    </div>
                    <div className="ads_details_metrics_tabs_content_card">
                      <div className="heading">
                        <h4>Impression Distribution by Gender</h4>
                        <span>This data shows the distribution of impressions based on the audience’s age and gender as per their Facebook profile at the time of ad delivery.</span>
                      </div>
                      <div className="content">
                        <div className="graph_content_container">
                          <PieChart
                            values={[
                              facebookAudienceData?.gender_distribution?.male,
                              facebookAudienceData?.gender_distribution?.female,
                              facebookAudienceData?.gender_distribution?.unknown
                            ]}
                            labels={[
                              'Male',
                              'Female',
                              'Unknown'
                            ]}
                            backgroundColors={[
                              '#9b87f5',
                              '#7e69ab',
                              '#6e59a5'

                            ]}
                            legend={true}



                          />
                        </div>

                      </div>

                    </div>

                  </div>
                  <div className="ads_details_metrics_tabs_content_container_bottom">
        
                    <div className="ads_details_metrics_tabs_content_card w-100">
                      <div className="heading">
                        <h4>Top Performing Locations (Impressions)</h4>
                        <span>This data shows the distribution of impressions based on the geographic locations of the audience at the time the ad was delivered, as recorded by Facebook.</span>
                      </div>
                      <div className="content w-100">
                        <div className={`locations-chart `} >
                          <div className="locations-bars">

                            {facebookAudienceData?.locations?.length==0 && <div className="d-flex justify-content-center align-items-center ">
                               <h4>No records found</h4>
                              </div>}
                            {facebookAudienceData?.locations?.length>0 && facebookAudienceData?.locations?.map((location) => {

                              return <div className="location-item w-100">
                                <div className="location-label">{location?.region}</div>
                                <div className="location-bar-container">
                                  <div className="location-bar" style={{ width: "" + (location?.impressions / facebookAudienceData?.facebook_total_impressions) * 100 + "%" }} />
                                  <div className="location-value">{location?.impressions}</div>
                                </div>
                              </div>

                            })}

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>}
              {adDetailsTab === "conversions" &&
                <div className="ads_details_metrics_tabs_content_container" style={{ minHeight: '70vh' }}>


                </div>}
              
                    <FacebookAdsPublisherPlatformMetricsList 
                    ads={adsData?.metrics_data?.platform_based_metrics}
                    
                    />
              

            </section>


          </div>

                      
                      </>}



                  </div>

                </div>
              </div> 
          


          </div>
          {/* new ad-details  */}

      
        
         


          
   
          <DateRangePicker
            showDateRangePicker={showDateRangePicker}
            setShowDateRangePicker={setShowDateRangePicker}
            dateRange={customRange}
            setDateRange={setCustomRange}
          />
        </div>}
    </>
  );
};

export default CampaignsViewMore;
